import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "table-page loading-page",
  id: "TablePage",
  "dark-class": "table-page-dark"
}
const _hoisted_2 = { class: "head-menu-box" }
const _hoisted_3 = { class: "operating-box" }
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = { class: "icon-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "添加记录", -1)
const _hoisted_7 = { class: "more-box" }
const _hoisted_8 = {
  class: "table-box",
  id: "TableID"
}
const _hoisted_9 = {
  class: "base-box",
  id: "BaseID"
}
const _hoisted_10 = { class: "content-box" }
const _hoisted_11 = { class: "head" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {"width":"15vmin"}
}, "S/N", -1)
const _hoisted_13 = { class: "body" }
const _hoisted_14 = {
  class: "column",
  style: {"width":"15vmin"}
}
const _hoisted_15 = { class: "column-box" }
const _hoisted_16 = { class: "text-box" }
const _hoisted_17 = {
  key: 0,
  class: "column-box"
}
const _hoisted_18 = {
  key: 0,
  class: "resource-box"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "image-box"
}
const _hoisted_21 = ["src", "alt", "title"]
const _hoisted_22 = {
  key: 1,
  class: "video-box"
}
const _hoisted_23 = ["src", "alt", "title"]
const _hoisted_24 = { class: "play-btn" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 1,
  class: "switch-box"
}
const _hoisted_27 = {
  key: 0,
  class: "text-box"
}
const _hoisted_28 = {
  key: 2,
  class: "text-box"
}
const _hoisted_29 = {
  key: 1,
  class: "column-box column-box-null"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "operating-title" }, "操作", -1)
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_41 = { class: "pagination-box" }
const _hoisted_42 = { class: "statistics-box" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "p" }, "显示", -1)
const _hoisted_44 = { class: "select-box" }
const _hoisted_45 = { class: "number" }
const _hoisted_46 = { class: "options-base" }
const _hoisted_47 = { class: "p" }
const _hoisted_48 = { class: "number-box" }
const _hoisted_49 = { class: "info-box" }
const _hoisted_50 = {
  class: "pages-box",
  "dark-class": "page-box-dark"
}
const _hoisted_51 = { class: "current-box" }
const _hoisted_52 = { class: "number" }
const _hoisted_53 = { class: "options-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_filter = _resolveComponent("elem-filter")!
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_ElemOperating = _resolveComponent("ElemOperating")!
  const _component_comp_menu = _resolveComponent("comp-menu")!
  const _component_elem_switch = _resolveComponent("elem-switch")!
  const _component_comp_entity = _resolveComponent("comp-entity")!
  const _component_comp_form = _resolveComponent("comp-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_elem_filter, {
        filters: _ctx.tableConfig.group,
        onOnChange: _ctx.onChangeFilter
      }, null, 8, ["filters", "onOnChange"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "search"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "输入搜索内容",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getData && _ctx.getData(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.search]
          ])
        ]),
        (_ctx.tableConfig.pages.indexOf('create') > -1)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn-box",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpForm({ type: 'create', name: _ctx.name })))
            }, [
              _createVNode(_component_elem_icon, {
                class: "icon",
                name: "add_white"
              }),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig.tableHeadOperatings, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "operating-btn",
            key: idx
          }, [
            _createVNode(_component_ElemOperating, {
              api: _ctx.api,
              page: _ctx.page,
              config: item,
              onOnRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getData()))
            }, null, 8, ["api", "page", "config"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_elem_icon, {
            class: "icon",
            name: "more"
          }),
          _createVNode(_component_comp_menu, {
            value: _ctx.getMoreMenu(_ctx.tableConfig)
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig.table, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx,
                style: _normalizeStyle({ width: (item.width / 8) + 'vmin' })
              }, _toDisplayString(item.title), 5))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(Number(idx + 1) + (_ctx.page - 1) * _ctx.limit), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig.table, (conf, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "column",
                    key: idx,
                    style: _normalizeStyle({ width: (conf.width / 8) + 'vmin' })
                  }, [
                    (_ctx.isExist(item[conf.field]))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (conf.type === 'Resource')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[conf.field] instanceof Array ? item[conf.field] : [item[conf.field]], (res, idx) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    class: "item-box",
                                    key: idx,
                                    href: res.domain + res.src,
                                    target: "view_window"
                                  }, [
                                    (conf.config.type === 'image')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          _createElementVNode("img", {
                                            class: "image",
                                            src: res.url,
                                            alt: res.name,
                                            title: res.name
                                          }, null, 8, _hoisted_21)
                                        ]))
                                      : (conf.config.type === 'video')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _createElementVNode("img", {
                                              class: "image",
                                              src: res.cover.url,
                                              alt: res.name,
                                              title: res.name
                                            }, null, 8, _hoisted_23),
                                            _createElementVNode("div", _hoisted_24, [
                                              _createVNode(_component_elem_icon, {
                                                class: "icon",
                                                name: "play"
                                              })
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(res.name), 1))
                                  ], 8, _hoisted_19))
                                }), 128))
                              ]))
                            : (conf.type === 'Switch')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  (conf.edit === false)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(item[conf.field] ? '是' : '否'), 1))
                                    : (_openBlock(), _createBlock(_component_elem_switch, {
                                        key: 1,
                                        size: "small",
                                        value: item[conf.field],
                                        onChange: ($event: any) => (_ctx.onChangeDataBySwitch($event, conf.field, item.uuid))
                                      }, null, 8, ["value", "onChange"]))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(item[conf.field]), 1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_29, "-"))
                  ], 4))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["operating-box", { 'operating-suspension': _ctx.suspension }])
        }, [
          _hoisted_30,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "operating-item",
              key: idx
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig.operatings, (conf, idx) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "button-box",
                  key: idx
                }, [
                  (conf.type === 'EDIT')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "edit",
                        onClick: ($event: any) => (_ctx.jumpForm({ type: 'edit', name: _ctx.name, i: item.uuid }))
                      }, "编辑", 8, _hoisted_31))
                    : (conf.type === 'DELETE')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "delete",
                          onClick: ($event: any) => (_ctx.onDelete(item.uuid))
                        }, "删除", 8, _hoisted_32))
                      : (conf.type === 'POPUP')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            style: _normalizeStyle({ background: conf.background, color: conf.color }),
                            onClick: ($event: any) => (_ctx.onOperatingPopup(item, conf.url, conf.msg, conf.config))
                          }, _toDisplayString(conf.title), 13, _hoisted_33))
                        : (conf.type === 'FILE')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              style: _normalizeStyle({ background: conf.background, color: conf.color }),
                              onClick: ($event: any) => (_ctx.onOperatingFile(item, conf.url, conf.msg, conf.config))
                            }, _toDisplayString(conf.title), 13, _hoisted_34))
                          : (conf.type === 'DOWNLOAD')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                style: _normalizeStyle({ background: conf.background, color: conf.color }),
                                onClick: ($event: any) => (_ctx.onOperatingDownload(item, conf))
                              }, _toDisplayString(conf.title), 13, _hoisted_35))
                            : (conf.type === 'JUMP')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 5,
                                  style: _normalizeStyle({ background: conf.background, color: conf.color }),
                                  onClick: ($event: any) => (_ctx.onOperatingJump(item, conf.url, conf.msg))
                                }, _toDisplayString(conf.title), 13, _hoisted_36))
                              : (conf.type === 'REQUEST')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 6,
                                    style: _normalizeStyle({ background: conf.background, color: conf.color }),
                                    onClick: ($event: any) => (_ctx.onOperatingRequest(conf.method, item, conf.url, conf.msg))
                                  }, _toDisplayString(conf.title), 13, _hoisted_37))
                                : (conf.type === 'FORM')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 7,
                                      style: _normalizeStyle({ background: conf.background, color: conf.color }),
                                      onClick: ($event: any) => (_ctx.onDisplayForm(conf, item))
                                    }, _toDisplayString(conf.title), 13, _hoisted_38))
                                  : (conf.type === 'ENTITY')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 8,
                                        class: "entity",
                                        onClick: ($event: any) => (_ctx.openEntity(item))
                                      }, _toDisplayString(conf.title), 9, _hoisted_39))
                                    : _createCommentVNode("", true)
                ])), [
                  [_vShow, conf.type === 'EDIT' ? _ctx.tableConfig.pages.indexOf('create') > -1 : true && _ctx.getConditionValue(conf.filter, item)]
                ])
              }), 128))
            ]))
          }), 128))
        ], 2)
      ]),
      _createVNode(_component_comp_entity, { ref: "comp_entity" }, null, 512),
      (!_ctx.table || 0 >= _ctx.table.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_40, "当前数据为空"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", {
            class: "select-base",
            "dark-class": "select-base-dark",
            tabindex: "0",
            hidefocus: "true",
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayLimitOptions = true)),
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.displayLimitOptions = false))
          }, [
            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.limit), 1),
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "select",
              dark: "select_white"
            })
          ], 32),
          _createElementVNode("div", {
            class: _normalizeClass(["options-box", { 'options-activity': _ctx.displayLimitOptions }])
          }, [
            _createElementVNode("div", _hoisted_46, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, idx) => {
                return _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSelectLimit && _ctx.onSelectLimit(...args))),
                  key: idx
                }, _toDisplayString(item * 10), 1)
              }), 64))
            ])
          ], 2)
        ]),
        _createElementVNode("p", _hoisted_47, "条记录/页，共 " + _toDisplayString(_ctx.totalElements) + " 条记录", 1)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, "当前第 " + _toDisplayString(_ctx.page) + " 页，共 " + _toDisplayString(_ctx.totalPages || 1) + " 页", 1),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", {
            class: _normalizeClass(["previous-box", { available: _ctx.page > 1 }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangePages('previous')))
          }, [
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "previous_white"
            })
          ], 2),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", {
              class: "select-base",
              tabindex: "0",
              hidefocus: "true",
              onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.displayPageOptions = true)),
              onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayPageOptions = false))
            }, [
              _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.page), 1),
              _createVNode(_component_elem_icon, {
                class: "icon",
                name: "select",
                dark: "select_white"
              })
            ], 32),
            _createElementVNode("div", {
              class: _normalizeClass(["options-box", { 'options-activity': _ctx.displayPageOptions }])
            }, [
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (item, idx) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "item",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onSelectPages && _ctx.onSelectPages(...args))),
                    key: idx
                  }, _toDisplayString(item), 1))
                }), 128))
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["next-box", { available: _ctx.totalPages > _ctx.page }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangePages('next')))
          }, [
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "next_white"
            })
          ], 2)
        ])
      ])
    ]),
    _createVNode(_component_comp_form, {
      ref: "comp_form",
      onOnSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getData()))
    }, null, 512)
  ]))
}